// extracted by mini-css-extract-plugin
export default {"input":"NumberingStartFrom_input__NyZEe"};